module.exports = __webpack_public_path__ + "img/11_2025_04_15.387df30f.jpg";